module.exports = __webpack_public_path__ + "static/media/trashbin-circle.99147446.svg";